<template>
  <div class="add2">
    <div class="topBar">
      <div class="subTitle">
        <i
          class="far fa-window-minimize"
          style="transform:rotate(90deg);margin-right: -5px;color:rgba(52,152,219,1);"
        ></i>选择商品分类
      </div>
    </div>

    <div style="width: 1056px;margin: 0 auto;background-color: #eee">
      <div class="clear" v-show="add222">
        <div class="clear-item col1">
          <div class="left_div">
            <i class="fas fa-bookmark fa-lg" style="margin-left:30px;color:white"></i>
            <div class="positi"></div>
            <p>基本信息</p>
          </div>
          <div class="left_div" style="margin-top: 950px">
            <i class="fas fa-bookmark fa-lg" style="margin-left:30px;color:white"></i>
            <div class="positi"></div>
            <p>商品相册</p>
          </div>
          <!-- <div class="item">基本信息</div>
          <div class="item" style="margin-top: 1070px;">商品相册</div>-->
        </div>
        <div class="clear-item col2">
          <form v-show="showfrom == '生物耗材/器具/瓶皿/液氮'">
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">商品分类:</div>
                </el-col>
                <el-col :span="20">
                  <div class="grid-content bg-purple input">{{showfrom}}</div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">商品名称:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val1"></el-input>
                  </div>
                </el-col>
                <el-col :span="10" class="ps1">*</el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">其他名称:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val16"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">商品货号:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val4"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">商品品牌:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-select v-model="val3" placeholder="请选择品牌">
                      <el-option v-for="item in options" :key="item" :label="item" :value="item"></el-option>
                    </el-select>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">产地:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="origin"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>

            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">货期:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val5"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>

            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">库存:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val6"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>

            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">进价:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val7"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>

            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">售价:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val8"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>

            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">原价:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val9"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">规格:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val12"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">应用:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val15"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <!-- <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">储放:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val18"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>-->
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">型号:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="model"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">材质:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="texture"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">颜色:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="color"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">排序:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="order_by"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">上传相关文档:</div>
                </el-col>
                <el-col :span="10">
                  <div id="docFlapce" style="margin-top:10px;">
                    <el-upload
                      class="upload-demo"
                      action
                      :limit="1"
                      :on-change="getFile11"
                      :auto-upload="false"
                    >
                      <el-button size="small" type="primary">点击上传</el-button>
                      <div slot="tip" class="el-upload__tip">只能上传pdf/word/wps文件，且不超过500kb</div>
                    </el-upload>
                    <span style="font-size: 12px;color: #606266;margin-top: 7px;">{{document1}}</span>
                  </div>
                </el-col>
              </el-row>
            </div>

            <div style="padding: 0 50px;">
              <div class="row">
                <div style="line-height: 40px;">上传图片:</div>

                <div class="clear" style="height:170px;margin-left:90px">
                  <div
                    v-show="img111111"
                    class="preview-img2 col"
                    style="text-align: center;line-height: 172px;"
                  >
                    <i class="fas fa-image fa-5x" style="color:#999"></i>
                  </div>
                  <div class="row" style="display:flex">
                    <!-- :file-list="fileList" -->
                    <img
                      v-if="IsfileListUrl"
                      :src="serve + fileListUrl"
                      alt
                      style="width:146px;height:146px;border-radius: 6px;margin-right:10px"
                    />
                    <el-upload
                      action
                      list-type="picture-card"
                      :auto-upload="false"
                      :limit="1"
                      :on-remove="removeImg"
                      :on-change="getImg11"
                    >
                      <i class="el-icon-plus"></i>
                    </el-upload>
                  </div>
                </div>
              </div>

              <div style="margin-left:90px" class="row">
                <el-dialog title="从相册上传" :visible.sync="dialogVisible" :modal="false" width="800px">
                  <div style="margin-bottom:20px;">
                    <el-select v-model="albumsId" placeholder="选择相册" @change="selChange()">
                      <el-option
                        v-for="item in albums"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </div>
                  <div>
                    <div
                      v-show="imagesSel != null && !imagesSel[0]"
                      style="text-align:center;color:#666;padding: 20px 0 "
                    >相册内无图片</div>
                    <el-row>
                      <el-col :span="4" v-for="item in imagesSel" :key="item.id" class="for">
                        <div class="item">
                          <img v-bind:src="serve+''+item.image" @click="set1ImgUrl(item.image)" />
                        </div>
                      </el-col>
                    </el-row>

                    <el-pagination
                      v-if="pager"
                      background
                      layout="prev, pager, next"
                      :total="pages"
                      :page-size="18"
                      @current-change="setPage"
                    ></el-pagination>
                  </div>
                  <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogVisible = false">取 消</el-button>
                  </span>
                </el-dialog>

                <button
                  class="button"
                  style="margin-top: 20px;"
                  @click="setImageFromServer($event)"
                >从相册上传</button>
              </div>

              <div class="row">
                <div style="line-height: 40px;">商品详情:</div>
                <div class="row">
                  <wanged-itor :info="rmark1" @change_edit="change_edit_set" />
                </div>
              </div>

              <div class="row">
                <el-switch
                  v-model="discounts"
                  inactive-text="是否为折扣商品"
                  active-value="1"
                  inactive-value="0"
                ></el-switch>
              </div>
              <div class="row">
                <el-switch
                  v-model="hot"
                  inactive-text="是否为商品排行"
                  active-value="1"
                  inactive-value="0"
                ></el-switch>
              </div>
              <div class="row">
                <el-switch
                  v-model="required"
                  inactive-text="是否为必抢清单"
                  active-value="1"
                  inactive-value="0"
                ></el-switch>
              </div>

              <div class="submit">
                <button class="button" @click="submit($event)">确认上传</button>
              </div>
            </div>
          </form>

          <form v-show="showfrom == '生物实验室办公/日用品'">
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">商品分类:</div>
                </el-col>
                <el-col :span="20">
                  <div class="grid-content bg-purple input">{{showfrom}}</div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">商品名称:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val1"></el-input>
                  </div>
                </el-col>
                <el-col :span="10" class="ps1">*</el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">其他名称:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val16"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">商品货号:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val4"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">商品品牌:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-select v-model="val3" placeholder="请选择品牌">
                      <el-option v-for="item in options" :key="item" :label="item" :value="item"></el-option>
                    </el-select>
                  </div>
                </el-col>
              </el-row>
            </div>

            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">产地:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="origin"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>

            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">货期:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val5"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>

            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">库存:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val6"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>

            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">进价:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val7"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>

            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">售价:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val8"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>

            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">原价:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val9"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">规格:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val12"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">应用:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val15"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <!-- <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">储放:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val18"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>-->
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">型号:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="model"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">材质:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="texture"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">颜色:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="color"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>

            <!-- <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">文档名称:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="typeNmae"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>-->
            <!-- <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">文档地址:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="typeSite"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>-->

            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">排序:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="order_by"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">上传相关文档:</div>
                </el-col>
                <el-col :span="10">
                  <div id="docFlapce" style="margin-top:10px;">
                    <el-upload
                      class="upload-demo"
                      action
                      :limit="1"
                      :on-change="getFile11"
                      :auto-upload="false"
                    >
                      <el-button size="small" type="primary">点击上传</el-button>
                      <div slot="tip" class="el-upload__tip">只能上传pdf/word/wps文件，且不超过500kb</div>
                    </el-upload>
                    <span style="font-size: 12px;color: #606266;margin-top: 7px;">{{document1}}</span>
                  </div>
                </el-col>
              </el-row>
            </div>

            <div style="padding: 0 50px;">
              <div class="row">
                <div style="line-height: 40px;">上传图片:</div>

                <div class="clear" style="height:170px;margin-left:90px">
                  <div
                    v-show="img111111"
                    class="preview-img2 col"
                    style="text-align: center;line-height: 172px;"
                  >
                    <i class="fas fa-image fa-5x" style="color:#999"></i>
                  </div>
                  <div class="row" style="display:flex">
                    <el-upload
                      action
                      list-type="picture-card"
                      :auto-upload="false"
                      :file-list="fileList"
                      :limit="1"
                      :on-remove="removeImg"
                      :on-change="getImg11"
                    >
                      <i class="el-icon-plus"></i>
                    </el-upload>
                  </div>
                </div>
              </div>

              <div style="margin-left:90px" class="row">
                <el-dialog title="从相册上传" :visible.sync="dialogVisible" :modal="false" width="800px">
                  <div style="margin-bottom:20px;">
                    <el-select v-model="albumsId" placeholder="选择相册" @change="selChange()">
                      <el-option
                        v-for="item in albums"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </div>
                  <div>
                    <div
                      v-show="imagesSel != null && !imagesSel[0]"
                      style="text-align:center;color:#666;padding: 20px 0 "
                    >相册内无图片</div>
                    <el-row>
                      <el-col :span="4" v-for="item in imagesSel" :key="item.id" class="for">
                        <div class="item">
                          <img v-bind:src="serve+''+item.image" @click="set1ImgUrl(item.image)" />
                        </div>
                      </el-col>
                    </el-row>

                    <el-pagination
                      v-if="pager"
                      background
                      layout="prev, pager, next"
                      :total="pages"
                      :page-size="18"
                      @current-change="setPage"
                    ></el-pagination>
                  </div>
                  <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogVisible = false">取 消</el-button>
                  </span>
                </el-dialog>

                <button
                  class="button"
                  style="margin-top: 20px;"
                  @click="setImageFromServer($event)"
                >从相册上传</button>
              </div>

              <div class="row">
                <div style="line-height: 40px;">商品详情:</div>
                <div class="row">
                  <wanged-itor :info="rmark1" @change_edit="change_edit_set" />
                </div>
              </div>

              <div class="row">
                <el-switch
                  v-model="discounts"
                  inactive-text="是否为折扣商品"
                  active-value="1"
                  inactive-value="0"
                ></el-switch>
              </div>
              <div class="row">
                <el-switch
                  v-model="hot"
                  inactive-text="是否为商品排行"
                  active-value="1"
                  inactive-value="0"
                ></el-switch>
              </div>
              <div class="row">
                <el-switch
                  v-model="required"
                  inactive-text="是否为必抢清单"
                  active-value="1"
                  inactive-value="0"
                ></el-switch>
              </div>

              <div class="submit">
                <button class="button" @click="submit($event)">确认上传</button>
              </div>
            </div>
          </form>
          <form v-show="showfrom == '试剂/生化/分子/细胞'">
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">商品分类:</div>
                </el-col>
                <el-col :span="20">
                  <div class="grid-content bg-purple input">{{showfrom}}</div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">商品名称:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val1"></el-input>
                  </div>
                </el-col>
                <el-col :span="10" class="ps1">*</el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">其他名称:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val16"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">商品货号:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val4"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">商品品牌:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-select v-model="val3" placeholder="请选择品牌">
                      <el-option v-for="item in options" :key="item" :label="item" :value="item"></el-option>
                    </el-select>
                  </div>
                </el-col>
              </el-row>
            </div>

            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">产地:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="origin"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>

            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">货期:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val5"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>

            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">库存:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val6"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>

            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">进价:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val7"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>

            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">售价:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val8"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>

            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">原价:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val9"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">规格:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val12"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">应用:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val15"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <!-- <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">储放:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val18"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>-->
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">型号:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="model"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <!-- <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">文档名称:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="typeNmae"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>-->
            <!-- <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">文档地址:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="typeSite"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>-->
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">属性:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="property"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">纯度:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="purity"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">分子式:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="molecular"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">分子量:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="weight"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">CAS:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="CAS"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">排序:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="order_by"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">上传相关文档:</div>
                </el-col>
                <el-col :span="10">
                  <div id="docFlapce" style="margin-top:10px;">
                    <el-upload
                      class="upload-demo"
                      action
                      :limit="1"
                      :on-change="getFile11"
                      :auto-upload="false"
                    >
                      <el-button size="small" type="primary">点击上传</el-button>
                      <div slot="tip" class="el-upload__tip">只能上传pdf/word/wps文件，且不超过500kb</div>
                    </el-upload>
                    <span style="font-size: 12px;color: #606266;margin-top: 7px;">{{document1}}</span>
                  </div>
                </el-col>
              </el-row>
            </div>

            <div style="padding: 0 50px;">
              <div class="row">
                <div style="line-height: 40px;">上传图片:</div>

                <div class="clear" style="height:170px;margin-left:90px">
                  <div
                    v-show="img111111"
                    class="preview-img2 col"
                    style="text-align: center;line-height: 172px;"
                  >
                    <i class="fas fa-image fa-5x" style="color:#999"></i>
                  </div>
                  <div class="row" style="display:flex">
                    <el-upload
                      action
                      list-type="picture-card"
                      :auto-upload="false"
                      :file-list="fileList"
                      :limit="1"
                      :on-remove="removeImg"
                      :on-change="getImg11"
                    >
                      <i class="el-icon-plus"></i>
                    </el-upload>
                  </div>
                </div>
              </div>

              <div style="margin-left:90px" class="row">
                <el-dialog title="从相册上传" :visible.sync="dialogVisible" :modal="false" width="800px">
                  <div style="margin-bottom:20px;">
                    <el-select v-model="albumsId" placeholder="选择相册" @change="selChange()">
                      <el-option
                        v-for="item in albums"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </div>
                  <div>
                    <div
                      v-show="imagesSel != null && !imagesSel[0]"
                      style="text-align:center;color:#666;padding: 20px 0 "
                    >相册内无图片</div>
                    <el-row>
                      <el-col :span="4" v-for="item in imagesSel" :key="item.id" class="for">
                        <div class="item">
                          <img v-bind:src="serve+''+item.image" @click="set1ImgUrl(item.image)" />
                        </div>
                      </el-col>
                    </el-row>

                    <el-pagination
                      v-if="pager"
                      background
                      layout="prev, pager, next"
                      :total="pages"
                      :page-size="18"
                      @current-change="setPage"
                    ></el-pagination>
                  </div>
                  <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogVisible = false">取 消</el-button>
                  </span>
                </el-dialog>

                <button
                  class="button"
                  style="margin-top: 20px;"
                  @click="setImageFromServer($event)"
                >从相册上传</button>
              </div>

              <div class="row">
                <div style="line-height: 40px;">商品详情:</div>
                <div class="row">
                  <wanged-itor :info="rmark1" @change_edit="change_edit_set" />
                </div>
              </div>

              <div class="row">
                <el-switch
                  v-model="discounts"
                  inactive-text="是否为折扣商品"
                  active-value="1"
                  inactive-value="0"
                ></el-switch>
              </div>
              <div class="row">
                <el-switch
                  v-model="hot"
                  inactive-text="是否为商品排行"
                  active-value="1"
                  inactive-value="0"
                ></el-switch>
              </div>
              <div class="row">
                <el-switch
                  v-model="required"
                  inactive-text="是否为必抢清单"
                  active-value="1"
                  inactive-value="0"
                ></el-switch>
              </div>

              <div class="submit">
                <button class="button" @click="submit($event)">确认上传</button>
              </div>
            </div>
          </form>
          <form v-show="showfrom == '抗体/WB/IHC/FC/ELISA'">
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">商品分类:</div>
                </el-col>
                <el-col :span="20">
                  <div class="grid-content bg-purple input">{{showfrom}}</div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">商品名称:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val1"></el-input>
                  </div>
                </el-col>
                <el-col :span="10" class="ps1">*</el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">其他名称:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val16"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">商品货号:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val4"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">商品品牌:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-select v-model="val3" placeholder="请选择品牌">
                      <el-option v-for="item in options" :key="item" :label="item" :value="item"></el-option>
                    </el-select>
                  </div>
                </el-col>
              </el-row>
            </div>

            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">产地:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="origin"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>

            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">货期:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val5"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>

            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">库存:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val6"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>

            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">进价:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val7"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>

            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">售价:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val8"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>

            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">原价:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val9"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">规格:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val12"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">应用:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val15"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <!-- <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">储放:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val18"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>-->
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">型号:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="model"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <!-- <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">文档名称:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="color"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>-->
            <!-- <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">文档地址:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="typeSite"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>-->
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">属性:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="property"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">宿主:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="host"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">纯度:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="purity"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">反应种属:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="species"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">分子量:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="weight"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">抗原信息:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="antigen"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">排序:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="order_by"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">上传相关文档:</div>
                </el-col>
                <el-col :span="10">
                  <div id="docFlapce" style="margin-top:10px;">
                    <el-upload
                      class="upload-demo"
                      action
                      :limit="1"
                      :on-change="getFile11"
                      :auto-upload="false"
                    >
                      <el-button size="small" type="primary">点击上传</el-button>
                      <div slot="tip" class="el-upload__tip">只能上传pdf/word/wps文件，且不超过500kb</div>
                    </el-upload>
                    <span style="font-size: 12px;color: #606266;margin-top: 7px;">{{document1}}</span>
                  </div>
                </el-col>
              </el-row>
            </div>

            <div style="padding: 0 50px;">
              <div class="row">
                <div style="line-height: 40px;">上传图片:</div>

                <div class="clear" style="height:170px;margin-left:90px">
                  <div
                    v-show="img111111"
                    class="preview-img2 col"
                    style="text-align: center;line-height: 172px;"
                  >
                    <i class="fas fa-image fa-5x" style="color:#999"></i>
                  </div>
                  <div class="row" style="display:flex">
                    <el-upload
                      action
                      list-type="picture-card"
                      :auto-upload="false"
                      :file-list="fileList"
                      :limit="1"
                      :on-remove="removeImg"
                      :on-change="getImg11"
                    >
                      <i class="el-icon-plus"></i>
                    </el-upload>
                  </div>
                </div>
              </div>

              <div style="margin-left:90px" class="row">
                <el-dialog title="从相册上传" :visible.sync="dialogVisible" :modal="false" width="800px">
                  <div style="margin-bottom:20px;">
                    <el-select v-model="albumsId" placeholder="选择相册" @change="selChange()">
                      <el-option
                        v-for="item in albums"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </div>
                  <div>
                    <div
                      v-show="imagesSel != null && !imagesSel[0]"
                      style="text-align:center;color:#666;padding: 20px 0 "
                    >相册内无图片</div>
                    <el-row>
                      <el-col :span="4" v-for="item in imagesSel" :key="item.id" class="for">
                        <div class="item">
                          <img v-bind:src="serve+''+item.image" @click="set1ImgUrl(item.image)" />
                        </div>
                      </el-col>
                    </el-row>

                    <el-pagination
                      v-if="pager"
                      background
                      layout="prev, pager, next"
                      :total="pages"
                      :page-size="18"
                      @current-change="setPage"
                    ></el-pagination>
                  </div>
                  <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogVisible = false">取 消</el-button>
                  </span>
                </el-dialog>

                <button
                  class="button"
                  style="margin-top: 20px;"
                  @click="setImageFromServer($event)"
                >从相册上传</button>
              </div>

              <div class="row">
                <div style="line-height: 40px;">商品详情:</div>
                <div class="row">
                  <wanged-itor :info="rmark1" @change_edit="change_edit_set" />
                </div>
              </div>

              <div class="row">
                <el-switch
                  v-model="discounts"
                  inactive-text="是否为折扣商品"
                  active-value="1"
                  inactive-value="0"
                ></el-switch>
              </div>
              <div class="row">
                <el-switch
                  v-model="hot"
                  inactive-text="是否为商品排行"
                  active-value="1"
                  inactive-value="0"
                ></el-switch>
              </div>
              <div class="row">
                <el-switch
                  v-model="required"
                  inactive-text="是否为必抢清单"
                  active-value="1"
                  inactive-value="0"
                ></el-switch>
              </div>

              <div class="submit">
                <button class="button" @click="submit($event)">确认上传</button>
              </div>
            </div>
          </form>
          <form v-show="showfrom == '实验室通用仪器/均质机' || showfrom == '实验台/货架/洁净装置'">
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">商品分类:</div>
                </el-col>
                <el-col :span="20">
                  <div class="grid-content bg-purple input">{{showfrom}}</div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">商品名称:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val1"></el-input>
                  </div>
                </el-col>
                <el-col :span="10" class="ps1">*</el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">其他名称:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val16"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">商品货号:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val4"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">商品品牌:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-select v-model="val3" placeholder="请选择品牌">
                      <el-option v-for="item in options" :key="item" :label="item" :value="item"></el-option>
                    </el-select>
                  </div>
                </el-col>
              </el-row>
            </div>

            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">产地:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="origin"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>

            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">货期:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val5"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>

            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">库存:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val6"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>

            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">进价:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val7"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">材质:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="texture"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>

            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">售价:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val8"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>

            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">原价:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val9"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">规格:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val12"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">应用:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val15"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <!-- <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">储放:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val18"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>-->
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">型号:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="model"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <!-- <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">文档名称:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="typeNmae"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>-->
            <!-- <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">文档地址:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="typeSite"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>-->
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">属性:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="property"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>

            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">参数:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="parameter"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">颜色:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="color"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">排序:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="order_by"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">上传相关文档:</div>
                </el-col>
                <el-col :span="10">
                  <div id="docFlapce" style="margin-top:10px;">
                    <el-upload
                      class="upload-demo"
                      action
                      :limit="1"
                      :on-change="getFile11"
                      :auto-upload="false"
                    >
                      <el-button size="small" type="primary">点击上传</el-button>
                      <div slot="tip" class="el-upload__tip">只能上传pdf/word/wps文件，且不超过500kb</div>
                    </el-upload>
                    <span style="font-size: 12px;color: #606266;margin-top: 7px;">{{document1}}</span>
                  </div>
                </el-col>
              </el-row>
            </div>

            <div style="padding: 0 50px;">
              <div class="row">
                <div style="line-height: 40px;">上传图片:</div>

                <div class="clear" style="height:170px;margin-left:90px">
                  <div
                    v-show="img111111"
                    class="preview-img2 col"
                    style="text-align: center;line-height: 172px;"
                  >
                    <i class="fas fa-image fa-5x" style="color:#999"></i>
                  </div>
                  <div class="row" style="display:flex">
                    <el-upload
                      action
                      list-type="picture-card"
                      :auto-upload="false"
                      :file-list="fileList"
                      :limit="1"
                      :on-remove="removeImg"
                      :on-change="getImg11"
                    >
                      <i class="el-icon-plus"></i>
                    </el-upload>
                  </div>
                </div>
              </div>

              <div style="margin-left:90px" class="row">
                <el-dialog title="从相册上传" :visible.sync="dialogVisible" :modal="false" width="800px">
                  <div style="margin-bottom:20px;">
                    <el-select v-model="albumsId" placeholder="选择相册" @change="selChange()">
                      <el-option
                        v-for="item in albums"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </div>
                  <div>
                    <div
                      v-show="imagesSel != null && !imagesSel[0]"
                      style="text-align:center;color:#666;padding: 20px 0 "
                    >相册内无图片</div>
                    <el-row>
                      <el-col :span="4" v-for="item in imagesSel" :key="item.id" class="for">
                        <div class="item">
                          <img v-bind:src="serve+''+item.image" @click="set1ImgUrl(item.image)" />
                        </div>
                      </el-col>
                    </el-row>

                    <el-pagination
                      v-if="pager"
                      background
                      layout="prev, pager, next"
                      :total="pages"
                      :page-size="18"
                      @current-change="setPage"
                    ></el-pagination>
                  </div>
                  <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogVisible = false">取 消</el-button>
                  </span>
                </el-dialog>

                <button
                  class="button"
                  style="margin-top: 20px;"
                  @click="setImageFromServer($event)"
                >从相册上传</button>
              </div>

              <div class="row">
                <div style="line-height: 40px;">商品详情:</div>
                <div class="row">
                  <wanged-itor :info="rmark1" @change_edit="change_edit_set" />
                </div>
              </div>

              <div class="row">
                <el-switch
                  v-model="discounts"
                  inactive-text="是否为折扣商品"
                  active-value="1"
                  inactive-value="0"
                ></el-switch>
              </div>
              <div class="row">
                <el-switch
                  v-model="hot"
                  inactive-text="是否为商品排行"
                  active-value="1"
                  inactive-value="0"
                ></el-switch>
              </div>
              <div class="row">
                <el-switch
                  v-model="required"
                  inactive-text="是否为必抢清单"
                  active-value="1"
                  inactive-value="0"
                ></el-switch>
              </div>

              <div class="submit">
                <button class="button" @click="submit($event)">确认上传</button>
              </div>
            </div>
          </form>
          <form v-show="showfrom == '实验动物/细胞株'">
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">商品分类:</div>
                </el-col>
                <el-col :span="20">
                  <div class="grid-content bg-purple input">{{showfrom}}</div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">商品名称:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val1"></el-input>
                  </div>
                </el-col>
                <el-col :span="10" class="ps1">*</el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">其他名称:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val16"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">商品货号:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val4"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">商品品牌:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-select v-model="val3" placeholder="请选择品牌">
                      <el-option v-for="item in options" :key="item" :label="item" :value="item"></el-option>
                    </el-select>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">产地:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="origin"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">货期:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val5"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>

            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">库存:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val6"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">种属:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="belong"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">等级:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="grade"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>

            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">进价:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val7"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">售价:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val8"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>

            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">原价:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val9"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>

            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">应用:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val15"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <!-- <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">储放:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val18"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>-->

            <!-- <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">文档名称:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="typeNmae"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>-->
            <!-- <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">文档地址:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="typeSite"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>-->
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">属性:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="property"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">排序:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="order_by"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">上传相关文档:</div>
                </el-col>
                <el-col :span="10">
                  <div id="docFlapce" style="margin-top:10px;">
                    <el-upload
                      class="upload-demo"
                      action
                      :limit="1"
                      :on-change="getFile11"
                      :auto-upload="false"
                    >
                      <el-button size="small" type="primary">点击上传</el-button>
                      <div slot="tip" class="el-upload__tip">只能上传pdf/word/wps文件，且不超过500kb</div>
                    </el-upload>
                    <span style="font-size: 12px;color: #606266;margin-top: 7px;">{{document1}}</span>
                  </div>
                </el-col>
              </el-row>
            </div>

            <div style="padding: 0 50px;">
              <div class="row">
                <div style="line-height: 40px;">上传图片:</div>

                <div class="clear" style="height:170px;margin-left:90px">
                  <div
                    v-show="img111111"
                    class="preview-img2 col"
                    style="text-align: center;line-height: 172px;"
                  >
                    <i class="fas fa-image fa-5x" style="color:#999"></i>
                  </div>
                  <div class="row" style="display:flex">
                    <el-upload
                      action
                      list-type="picture-card"
                      :auto-upload="false"
                      :file-list="fileList"
                      :limit="1"
                      :on-remove="removeImg"
                      :on-change="getImg11"
                    >
                      <i class="el-icon-plus"></i>
                    </el-upload>
                  </div>
                </div>
              </div>

              <div style="margin-left:90px" class="row">
                <el-dialog title="从相册上传" :visible.sync="dialogVisible" :modal="false" width="800px">
                  <div style="margin-bottom:20px;">
                    <el-select v-model="albumsId" placeholder="选择相册" @change="selChange()">
                      <el-option
                        v-for="item in albums"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </div>
                  <div>
                    <div
                      v-show="imagesSel != null && !imagesSel[0]"
                      style="text-align:center;color:#666;padding: 20px 0 "
                    >相册内无图片</div>
                    <el-row>
                      <el-col :span="4" v-for="item in imagesSel" :key="item.id" class="for">
                        <div class="item">
                          <img v-bind:src="serve+''+item.image" @click="set1ImgUrl(item.image)" />
                        </div>
                      </el-col>
                    </el-row>

                    <el-pagination
                      v-if="pager"
                      background
                      layout="prev, pager, next"
                      :total="pages"
                      :page-size="18"
                      @current-change="setPage"
                    ></el-pagination>
                  </div>
                  <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogVisible = false">取 消</el-button>
                  </span>
                </el-dialog>

                <button
                  class="button"
                  style="margin-top: 20px;"
                  @click="setImageFromServer($event)"
                >从相册上传</button>
              </div>

              <div class="row">
                <div style="line-height: 40px;">商品详情:</div>
                <div class="row">
                  <wanged-itor :info="rmark1" @change_edit="change_edit_set" />
                </div>
              </div>

              <div class="row">
                <el-switch
                  v-model="discounts"
                  inactive-text="是否为折扣商品"
                  active-value="1"
                  inactive-value="0"
                ></el-switch>
              </div>
              <div class="row">
                <el-switch
                  v-model="hot"
                  inactive-text="是否为商品排行"
                  active-value="1"
                  inactive-value="0"
                ></el-switch>
              </div>
              <div class="row">
                <el-switch
                  v-model="required"
                  inactive-text="是否为必抢清单"
                  active-value="1"
                  inactive-value="0"
                ></el-switch>
              </div>

              <div class="submit">
                <button class="button" @click="submit($event)">确认上传</button>
              </div>
            </div>
          </form>
          <form v-show="showfrom == '技术服务/纯化/抗体定制'">
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">商品分类:</div>
                </el-col>
                <el-col :span="20">
                  <div class="grid-content bg-purple input">{{showfrom}}</div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">商品名称:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val1"></el-input>
                  </div>
                </el-col>
                <el-col :span="10" class="ps1">*</el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">其他名称:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val16"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">商品货号:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val4"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">商品品牌:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-select v-model="val3" placeholder="请选择品牌">
                      <el-option v-for="item in options" :key="item" :label="item" :value="item"></el-option>
                    </el-select>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">产地:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="origin"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">货期:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val5"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">进价:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val7"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">售价:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val8"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>

            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">原价:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val9"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>

            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">应用:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val15"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <!-- <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">储放:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val18"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>-->

            <!-- <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">文档名称:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="typeNmae"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>-->
            <!-- <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">文档地址:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="typeSite"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>-->
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">排序:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="order_by"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>

            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">上传相关文档:</div>
                </el-col>
                <el-col :span="10">
                  <div id="docFlapce" style="margin-top:10px;">
                    <el-upload
                      class="upload-demo"
                      action
                      :limit="1"
                      :on-change="getFile11"
                      :auto-upload="false"
                    >
                      <el-button size="small" type="primary">点击上传</el-button>
                      <div slot="tip" class="el-upload__tip">只能上传pdf/word/wps文件，且不超过500kb</div>
                    </el-upload>
                    <span style="font-size: 12px;color: #606266;margin-top: 7px;">{{document1}}</span>
                  </div>
                </el-col>
              </el-row>
            </div>

            <div style="padding: 0 50px;">
              <div class="row">
                <div style="line-height: 40px;">上传图片:</div>

                <div class="clear" style="height:170px;margin-left:90px">
                  <div
                    v-show="img111111"
                    class="preview-img2 col"
                    style="text-align: center;line-height: 172px;"
                  >
                    <i class="fas fa-image fa-5x" style="color:#999"></i>
                  </div>
                  <div class="row" style="display:flex">
                    <el-upload
                      action
                      list-type="picture-card"
                      :auto-upload="false"
                      :file-list="fileList"
                      :limit="1"
                      :on-remove="removeImg"
                      :on-change="getImg11"
                    >
                      <i class="el-icon-plus"></i>
                    </el-upload>
                  </div>
                </div>
              </div>

              <div style="margin-left:90px" class="row">
                <el-dialog title="从相册上传" :visible.sync="dialogVisible" :modal="false" width="800px">
                  <div style="margin-bottom:20px;">
                    <el-select v-model="albumsId" placeholder="选择相册" @change="selChange()">
                      <el-option
                        v-for="item in albums"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </div>
                  <div>
                    <div
                      v-show="imagesSel != null && !imagesSel[0]"
                      style="text-align:center;color:#666;padding: 20px 0 "
                    >相册内无图片</div>
                    <el-row>
                      <el-col :span="4" v-for="item in imagesSel" :key="item.id" class="for">
                        <div class="item">
                          <img v-bind:src="serve+''+item.image" @click="set1ImgUrl(item.image)" />
                        </div>
                      </el-col>
                    </el-row>

                    <el-pagination
                      v-if="pager"
                      background
                      layout="prev, pager, next"
                      :total="pages"
                      :page-size="18"
                      @current-change="setPage"
                    ></el-pagination>
                  </div>
                  <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogVisible = false">取 消</el-button>
                  </span>
                </el-dialog>

                <button
                  class="button"
                  style="margin-top: 20px;"
                  @click="setImageFromServer($event)"
                >从相册上传</button>
              </div>

              <div class="row">
                <div style="line-height: 40px;">商品详情:</div>
                <div class="row">
                  <wanged-itor :info="rmark1" @change_edit="change_edit_set" />
                </div>
              </div>

              <div class="row">
                <el-switch
                  v-model="discounts"
                  inactive-text="是否为折扣商品"
                  active-value="1"
                  inactive-value="0"
                ></el-switch>
              </div>
              <div class="row">
                <el-switch
                  v-model="hot"
                  inactive-text="是否为商品排行"
                  active-value="1"
                  inactive-value="0"
                ></el-switch>
              </div>
              <div class="row">
                <el-switch
                  v-model="required"
                  inactive-text="是否为必抢清单"
                  active-value="1"
                  inactive-value="0"
                ></el-switch>
              </div>

              <div class="submit">
                <button class="button" @click="submit($event)">确认上传</button>
              </div>
            </div>
          </form>
          <form v-show="showfrom == '生物软件/统计绘图办公'">
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">商品分类:</div>
                </el-col>
                <el-col :span="20">
                  <div class="grid-content bg-purple input">{{showfrom}}</div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">商品名称:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val1"></el-input>
                  </div>
                </el-col>
                <el-col :span="10" class="ps1">*</el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">其他名称:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val16"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">商品货号:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val4"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">商品品牌:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-select v-model="val3" placeholder="请选择品牌">
                      <el-option v-for="item in options" :key="item" :label="item" :value="item"></el-option>
                    </el-select>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">货期:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val5"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">产地:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="origin"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">进价:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val7"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">售价:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val8"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>

            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">原价:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val9"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>

            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">应用:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val15"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">型号:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="model"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>

            <!-- <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">文档名称:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="typeNmae"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>-->
            <!-- <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">文档地址:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="typeSite"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>-->
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">排序:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="order_by"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">上传相关文档:</div>
                </el-col>
                <el-col :span="10">
                  <div id="docFlapce" style="margin-top:10px;">
                    <el-upload
                      class="upload-demo"
                      action
                      :limit="1"
                      :on-change="getFile11"
                      :auto-upload="false"
                    >
                      <el-button size="small" type="primary">点击上传</el-button>
                      <div slot="tip" class="el-upload__tip">只能上传pdf/word/wps文件，且不超过500kb</div>
                    </el-upload>
                    <span style="font-size: 12px;color: #606266;margin-top: 7px;">{{document1}}</span>
                  </div>
                </el-col>
              </el-row>
            </div>

            <div style="padding: 0 50px;">
              <div class="row">
                <div style="line-height: 40px;">上传图片:</div>

                <div class="clear" style="height:170px;margin-left:90px">
                  <div
                    v-show="img111111"
                    class="preview-img2 col"
                    style="text-align: center;line-height: 172px;"
                  >
                    <i class="fas fa-image fa-5x" style="color:#999"></i>
                  </div>
                  <div class="row" style="display:flex">
                    <el-upload
                      action
                      list-type="picture-card"
                      :auto-upload="false"
                      :file-list="fileList"
                      :limit="1"
                      :on-remove="removeImg"
                      :on-change="getImg11"
                    >
                      <i class="el-icon-plus"></i>
                    </el-upload>
                  </div>
                </div>
              </div>

              <div style="margin-left:90px" class="row">
                <el-dialog title="从相册上传" :visible.sync="dialogVisible" :modal="false" width="800px">
                  <div style="margin-bottom:20px;">
                    <el-select v-model="albumsId" placeholder="选择相册" @change="selChange()">
                      <el-option
                        v-for="item in albums"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </div>
                  <div>
                    <div
                      v-show="imagesSel != null && !imagesSel[0]"
                      style="text-align:center;color:#666;padding: 20px 0 "
                    >相册内无图片</div>
                    <el-row>
                      <el-col :span="4" v-for="item in imagesSel" :key="item.id" class="for">
                        <div class="item">
                          <img v-bind:src="serve+''+item.image" @click="set1ImgUrl(item.image)" />
                        </div>
                      </el-col>
                    </el-row>

                    <el-pagination
                      v-if="pager"
                      background
                      layout="prev, pager, next"
                      :total="pages"
                      :page-size="18"
                      @current-change="setPage"
                    ></el-pagination>
                  </div>
                  <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogVisible = false">取 消</el-button>
                  </span>
                </el-dialog>

                <button
                  class="button"
                  style="margin-top: 20px;"
                  @click="setImageFromServer($event)"
                >从相册上传</button>
              </div>

              <div class="row">
                <div style="line-height: 40px;">商品详情:</div>
                <div class="row">
                  <wanged-itor :info="rmark1" @change_edit="change_edit_set" />
                </div>
              </div>

              <div class="row">
                <el-switch
                  v-model="discounts"
                  inactive-text="是否为折扣商品"
                  active-value="1"
                  inactive-value="0"
                ></el-switch>
              </div>
              <div class="row">
                <el-switch
                  v-model="hot"
                  inactive-text="是否为商品排行"
                  active-value="1"
                  inactive-value="0"
                ></el-switch>
              </div>
              <div class="row">
                <el-switch
                  v-model="required"
                  inactive-text="是否为必抢清单"
                  active-value="1"
                  inactive-value="0"
                ></el-switch>
              </div>

              <div class="submit">
                <button class="button" @click="submit($event)">确认上传</button>
              </div>
            </div>
          </form>
          <form v-show="showfrom == '书城/医学/生物'">
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">商品分类:</div>
                </el-col>
                <el-col :span="20">
                  <div class="grid-content bg-purple input">{{showfrom}}</div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">商品名称:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val1"></el-input>
                  </div>
                </el-col>
                <el-col :span="10" class="ps1">*</el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">其他名称:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val16"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">商品货号:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val4"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">商品品牌:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-select v-model="val3" placeholder="请选择品牌">
                      <el-option v-for="item in options" :key="item" :label="item" :value="item"></el-option>
                    </el-select>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">出版社:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="publishing"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">主编:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="editor_chief"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">出版时间:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="publi_time"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">材质:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="texture"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>

            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">库存:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val6"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">进价:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val7"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">售价:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val8"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>

            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">原价:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val9"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>

            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">应用:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val15"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">型号:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="model"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>

            <!-- <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">文档名称:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="typeNmae"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>-->
            <!-- <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">文档地址:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="typeSite"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>-->
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">排序:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="order_by"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">上传相关文档:</div>
                </el-col>
                <el-col :span="10">
                  <div id="docFlapce" style="margin-top:10px;">
                    <el-upload
                      class="upload-demo"
                      action
                      :limit="1"
                      :on-change="getFile11"
                      :auto-upload="false"
                    >
                      <el-button size="small" type="primary">点击上传</el-button>
                      <div slot="tip" class="el-upload__tip">只能上传pdf/word/wps文件，且不超过500kb</div>
                    </el-upload>
                    <span style="font-size: 12px;color: #606266;margin-top: 7px;">{{document1}}</span>
                  </div>
                </el-col>
              </el-row>
            </div>

            <div style="padding: 0 50px;">
              <div class="row">
                <div style="line-height: 40px;">上传图片:</div>

                <div class="clear" style="height:170px;margin-left:90px">
                  <div
                    v-show="img111111"
                    class="preview-img2 col"
                    style="text-align: center;line-height: 172px;"
                  >
                    <i class="fas fa-image fa-5x" style="color:#999"></i>
                  </div>
                  <div class="row" style="display:flex">
                    <el-upload
                      action
                      list-type="picture-card"
                      :auto-upload="false"
                      :file-list="fileList"
                      :limit="1"
                      :on-remove="removeImg"
                      :on-change="getImg11"
                    >
                      <i class="el-icon-plus"></i>
                    </el-upload>
                  </div>
                </div>
              </div>

              <div style="margin-left:90px" class="row">
                <el-dialog title="从相册上传" :visible.sync="dialogVisible" :modal="false" width="800px">
                  <div style="margin-bottom:20px;">
                    <el-select v-model="albumsId" placeholder="选择相册" @change="selChange()">
                      <el-option
                        v-for="item in albums"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </div>
                  <div>
                    <div
                      v-show="imagesSel != null && !imagesSel[0]"
                      style="text-align:center;color:#666;padding: 20px 0 "
                    >相册内无图片</div>
                    <el-row>
                      <el-col :span="4" v-for="item in imagesSel" :key="item.id" class="for">
                        <div class="item">
                          <img v-bind:src="serve+''+item.image" @click="set1ImgUrl(item.image)" />
                        </div>
                      </el-col>
                    </el-row>

                    <el-pagination
                      v-if="pager"
                      background
                      layout="prev, pager, next"
                      :total="pages"
                      :page-size="18"
                      @current-change="setPage"
                    ></el-pagination>
                  </div>
                  <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogVisible = false">取 消</el-button>
                  </span>
                </el-dialog>

                <button
                  class="button"
                  style="margin-top: 20px;"
                  @click="setImageFromServer($event)"
                >从相册上传</button>
              </div>

              <div class="row">
                <div style="line-height: 40px;">商品详情:</div>
                <div class="row">
                  <wanged-itor :info="rmark1" @change_edit="change_edit_set" />
                </div>
              </div>

              <div class="row">
                <el-switch
                  v-model="discounts"
                  inactive-text="是否为折扣商品"
                  active-value="1"
                  inactive-value="0"
                ></el-switch>
              </div>
              <div class="row">
                <el-switch
                  v-model="hot"
                  inactive-text="是否为商品排行"
                  active-value="1"
                  inactive-value="0"
                ></el-switch>
              </div>
              <div class="row">
                <el-switch
                  v-model="required"
                  inactive-text="是否为必抢清单"
                  active-value="1"
                  inactive-value="0"
                ></el-switch>
              </div>

              <div class="submit">
                <button class="button" @click="submit($event)">确认上传</button>
              </div>
            </div>
          </form>
          <form v-show="showfrom == '生物制药/试剂/设备/耗材'">
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">商品分类:</div>
                </el-col>
                <el-col :span="20">
                  <div class="grid-content bg-purple input">{{showfrom}}</div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">商品名称:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val1"></el-input>
                  </div>
                </el-col>
                <el-col :span="10" class="ps1">*</el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">其他名称:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val16"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">商品货号:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val4"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">商品品牌:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-select v-model="val3" placeholder="请选择品牌">
                      <el-option v-for="item in options" :key="item" :label="item" :value="item"></el-option>
                    </el-select>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">产地:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="origin"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">货期:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val5"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">型号:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="model"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">参数:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="parameter"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">材质:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="texture"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">颜色:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="color"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">属性:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="property"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">纯度:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="purity"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">规格:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val12"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">应用:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val15"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>

            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">分子式:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="molecular"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">分子量:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="weight"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">CAS:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="CAS"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>

            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">宿主:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="host"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>

            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">反应种属:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="species"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">种属:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="belong"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>

            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">等级:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="grade"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">主编:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="editor_chief"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>

            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">出版社:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="publishing"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>

            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">出版时间:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="publi_time"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>

            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">存放条件:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="deposit"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>

            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">进价:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val7"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>

            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">原价:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val8"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>

            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">售价:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val9"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>

            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">库存:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="val6"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <!-- <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">文档名称:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="typeNmae"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>-->
            <!-- <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">文档地址:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="typeSite"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>-->
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">排序:</div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple input">
                    <el-input v-model="order_by"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="row">
              <el-row>
                <el-col :span="4">
                  <div class="grid-content bg-purple label">上传相关文档:</div>
                </el-col>
                <el-col :span="10">
                  <div id="docFlapce" style="margin-top:10px;">
                    <el-upload
                      class="upload-demo"
                      action
                      :limit="1"
                      :on-change="getFile11"
                      :auto-upload="false"
                    >
                      <el-button size="small" type="primary">点击上传</el-button>
                      <div slot="tip" class="el-upload__tip">只能上传pdf/word/wps文件，且不超过500kb</div>
                    </el-upload>
                    <span style="font-size: 12px;color: #606266;margin-top: 7px;">{{document1}}</span>
                  </div>
                </el-col>
              </el-row>
            </div>

            <div style="padding: 0 50px;">
              <div class="row">
                <div style="line-height: 40px;">上传图片:</div>

                <div class="clear" style="height:170px;margin-left:90px">
                  <div
                    v-show="img111111"
                    class="preview-img2 col"
                    style="text-align: center;line-height: 172px;"
                  >
                    <i class="fas fa-image fa-5x" style="color:#999"></i>
                  </div>
                  <div class="row" style="display:flex">
                    <el-upload
                      action
                      list-type="picture-card"
                      :auto-upload="false"
                      :file-list="fileList"
                      :limit="1"
                      :on-remove="removeImg"
                      :on-change="getImg11"
                    >
                      <i class="el-icon-plus"></i>
                    </el-upload>
                  </div>
                </div>
              </div>
              <div style="margin-left:90px" class="row">
                <el-dialog title="从相册上传" :visible.sync="dialogVisible" width="800px" :modal="false">
                  <div style="margin-bottom:20px;">
                    <el-select v-model="albumsId" placeholder="选择相册" @change="selChange()">
                      <el-option
                        v-for="item in albums"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </div>
                  <div>
                    <div
                      v-show="imagesSel != null && !imagesSel[0]"
                      style="text-align:center;color:#666;padding: 20px 0 "
                    >相册内无图片</div>
                    <el-row>
                      <el-col :span="4" v-for="item in imagesSel" :key="item.id" class="for">
                        <div class="item">
                          <img v-bind:src="serve+''+item.image" @click="set1ImgUrl(item.image)" />
                        </div>
                      </el-col>
                    </el-row>
                    <el-pagination
                      v-if="pager"
                      background
                      layout="prev, pager, next"
                      :total="pages"
                      :page-size="18"
                      @current-change="setPage"
                    ></el-pagination>
                  </div>
                  <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogVisible = false">取 消</el-button>
                  </span>
                </el-dialog>
                <button
                  class="button"
                  style="margin-top: 20px;"
                  @click="setImageFromServer($event)"
                >从相册上传</button>
              </div>

              <div class="row">
                <div style="line-height: 40px;">商品详情:</div>
                <div class="row">
                  <wanged-itor :info="rmark1" @change_edit="change_edit_set" />
                </div>
              </div>

              <div class="row">
                <el-switch
                  v-model="discounts"
                  inactive-text="是否为折扣商品"
                  active-value="1"
                  inactive-value="0"
                ></el-switch>
              </div>
              <div class="row">
                <el-switch
                  v-model="hot"
                  inactive-text="是否为商品排行"
                  active-value="1"
                  inactive-value="0"
                ></el-switch>
              </div>
              <div class="row">
                <el-switch
                  v-model="required"
                  inactive-text="是否为必抢清单"
                  active-value="1"
                  inactive-value="0"
                ></el-switch>
              </div>

              <div class="submit">
                <button class="button" @click="submit($event)">确认上传</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
import WangedItor from "../components/wangeditor";
export default {
  components: {
    WangedItor
  },
  data() {
    return {
      IsfileListUrl: true,
      fileListUrl: "",
      serve: this.$store.state.serve,
      rmark1: null,
      rmark2: null,
      add222: false,
      showfrom: "",
      val1: "",
      val16: "",
      val4: "",
      val3: "",
      origin: "",
      val5: "",
      val6: "",
      val7: "",
      val8: "",
      val9: "",
      val12: "",
      val15: "",
      val18: "",
      model: "",
      texture: "",
      color: "",
      typeNmae: "",
      typeSite: "",
      property: "",
      purity: "",
      molecular: "",
      weight: "",
      CAS: "",
      host: "",
      species: "",
      belong: "",
      antigen: "",
      parameter: "",
      grade: "",
      publishing: "",
      editor_chief: "",
      publi_time: "",
      deposit: "",
      // ++++++++++++++++++++++++++
      fileList: [],
      img111111: false,
      CAS: "",
      address: "",
      alias: "",
      antigen_info: "",
      author: "",
      brand: "",
      buy_price: "",
      classification: "",
      create_date: "",
      discount_num: "",
      discounts: "",
      document: "",
      download_link: "",
      formula: "",
      host: "",
      hot: "",

      images: "",
      info: "",
      inventory: "",
      item_no: "",
      leadtime: "",
      molecular_weight: "",
      no: "",
      order_by: "",
      original_price: "",
      purity: "",
      quality: "",
      required: "",
      sales: "",
      second_class: "",
      selling: "",
      selling_price: "",
      species: "",
      specification: "",
      tag: "",
      temperature: "",
      third_class: "",
      title: "",
      top_class: "",
      update_date: "",
      uses: "",
      views: "",
      options: [],
      username: "",
      token: "",
      id: this.$route.params.id,
      list_page: this.$route.query.page,
      img1: null,
      img2: null,
      img3: null,
      src1: null,
      src2: null,
      src3: null,
      img1Type: "url",
      img2Type: "url",
      img3Type: "url",
      reader: new FileReader(),
      dialogVisible: false,
      imagesSel: null,
      albumsId: null,
      albums: [],
      page: 1,
      pages: null,
      pager: false,
      rmark: "",
      document1: "",
      fileListImg: []
    };
  },
  created() {
    this.$store.state.topActiveId = 2;
    this.$store.state.leftTitle = "商品列表";
    this.geting();
    this.gloup();
    console.log(this.$route);
  },
  methods: {
    change_edit_set(data) {
      this.rmark2 = data;
    },
    handimg(file, Editor, cursorLocation, resetUploader) {
      let config = {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      };
      var formData = new FormData();
      formData.append("img", file);
      formData.append("username", this.username);
      formData.append("token", this.token);
      this.axios
        .post(this.serve + "/admin/edit_upload_img", formData, config)
        .then(res => {
          Editor.insertEmbed(cursorLocation, "image", res.data.data);
          resetUploader();
        });
    },
    removeImg(file, fileList) {
      this.fileList = [];
      this.img1 = null;
    },
    getFile11(file, fileList) {
      this.document1 = "";
      this.document = file.raw;
    },
    getImg11(file, fileList) {
      this.IsfileListUrl = false;
      this.img1 = file.raw;
      this.img1Type = "file";
    },

    uploadDoc(r) {},
    gloup() {
      this.axios
        .get(this.serve + "/admin/get_brand_name", {
          params: {
            username: this.username,
            token: this.token
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            this.options = res.data.data;
          }
        });
    },
    geting() {
      const loading = this.$loading({
        lock: true,
        text: "玩命加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)"
      });
      this.username = this.$cookies.get("username");
      this.token = this.$cookies.get("token");
      this.axios
        .get(this.serve + "/admin/get_product_detail", {
          params: {
            username: this.username,
            token: this.token,
            p_id: this.id
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            loading.close();
            this.add222 = true;
            var json = res.data.data;
            this.CAS = json.CAS;
            this.val1 = json.title;
            this.val4 = json.item_no;
            this.val3 = json.brand;
            this.origin = json.origin;
            this.val5 = json.leadtime;
            this.val16 = json.common_title;
            this.val7 = json.buy_price;
            this.val8 = json.selling_price;
            this.val9 = json.original_price;
            this.val12 = json.specification;
            this.val15 = json.uses;
            this.model = json.model;
            this.texture = json.texture;
            this.color = json.color;
            this.property = json.property;
            this.purity = json.purity;
            this.molecular = json.molecular;
            this.weight = json.formula;
            this.host = json.host;
            this.species = json.reaction_species;
            this.belong = json.belong;
            this.antigen = json.antigen_info;
            this.parameter = json.paramater;
            this.grade = json.grade;
            this.publishing = json.press;
            this.editor_chief = json.editor;
            this.publi_time = json.press_time;
            this.deposit = json.save_contidion;
            this.showfrom = json.top_class;
            this.val6 = json.inventory;
            this.document1 = json.document;
            this.discounts = json.discounts;
            this.rmark1 = json.info;
            this.hot = json.hot;
            this.required = json.required;
            this.order_by = json.order_by;
            // console.log()
            this.fileListUrl = json.images;
            var imgNum = json.images.split(";");

            if (imgNum[0] != "" && imgNum[0] != "null") {
              this.fileList.push({
                url: this.serve + "" + imgNum[0]
              });
            }
            this.img1 = imgNum[0];
            this.img2 = imgNum[1];
            this.img3 = imgNum[2];
          }
        });
    },
    selChange() {
      this.getImages();
    },
    setPage(v) {
      this.page = v;
      this.getImages();
    },
    getImages() {
      var that = this;
      this.pager = true;
      this.axios
        .get(this.serve + "/admin/get_photo_images2", {
          params: {
            page: this.page,
            group_id: this.albumsId,
            username: this.username,
            token: this.token
          }
        })
        .then(function(res) {
          var json = res.data;
          that.checked = [];
          that.page = json.now_page;
          that.pages = json.page_num;
          delete json["now_page"];
          delete json["page_num"];
          for (var item in json) {
            that.checked[json[item].id] = false;
          }
          that.selectAll = false;
          that.imagesSel = json;
        });
    },
    getImg1(event) {
      this.img111111 = false;
      this.img1 = event.target.files[0];
      this.reader.readAsDataURL(this.img1);
      var that = this;
      this.reader.onload = function() {
        that.src1 = that.reader.result;
      };
      this.img1Type = "file";
    },
    getImg2(event) {
      this.img111111 = false;
      this.img2 = event.target.files[0];
      this.reader.readAsDataURL(this.img2);
      var that = this;
      this.reader.onload = function() {
        that.src2 = that.reader.result;
      };
      this.img2Type = "file";
    },
    getImg3(event) {
      this.img111111 = false;
      this.img3 = event.target.files[0];
      this.reader.readAsDataURL(this.img3);
      var that = this;
      this.reader.onload = function() {
        that.src3 = that.reader.result;
      };
      this.img3Type = "file";
    },
    getFile(event) {
      this.doc = event.target.files[0];
    },
    uploadDoc() {
      $("#docFile").click();
    },
    setImageFromLocal(e) {
      e.preventDefault();
      if (this.img1 == "") {
        $("#img1").click();
        return;
      }
      if (this.img2 == "") {
        $("#img2").click();
        return;
      }
      if (this.img3 == "") {
        $("#img3").click();
        return;
      }
      this.$message.error("最多上传3张图片");
    },
    set1ImgUrl(url) {
      this.img111111 = false;
      this.dialogVisible = false;
      this.fileList = [];
      this.fileList.push({
        url: this.serve + url
      });
      this.img1 = url;
      this.img1Type = "url";

      // if (this.img1 == "") {
      //   this.img1 = url;
      //   this.src1 = url;
      //   this.img1Type = "url";
      //   return;
      // }
      // if (this.img2 == "") {
      //   this.img2 = url;
      //   this.src2 = url;
      //   this.img2Type = "url";
      //   return;
      // }
      // if (this.img3 == "") {
      //   this.img3 = url;
      //   this.src3 = url;
      //   this.img3Type = "url";
      //   return;
      // }
      // this.$message.error("最多上传1张图片");
      // alert("最多上传3张图片");
    },
    setImageFromServer(e) {
      e.preventDefault();
      var that = this;
      this.dialogVisible = true;
      this.axios
        .get(this.serve + "/admin/get_photo_album", {
          params: { page: this.page }
        })
        .then(function(res) {
          var json = res.data;
          that.page = json.now_page;
          that.pages = json.page_num;
          var newAlbums = [];
          for (var key in json) {
            if (json[key].name) {
              newAlbums.push(json[key]);
            }
          }
          that.albums = [];
          that.albums = newAlbums;
        });
    },
    delDoc(e) {
      e.preventDefault();
      this.doc = null;
    },
    delImage(e, id) {
      e.preventDefault();
      // if (id == "1") {
      //   this.img111111 = true;
      // }
      switch (id) {
        case 1:
          this.img1 = "";
          this.src1 = null;
          this.img1Type = 0;
          $("#img1").val(null);
          break;
        case 2:
          this.img2 = "";
          this.src2 = null;
          this.img2Type = 0;
          $("#img2").val(null);
          break;
        case 3:
          this.src3 = null;
          this.img3 = "";
          this.img3Type = 0;
          $("#img3").val(null);
          break;
      }
    },
    submit(e) {
      e.preventDefault();
      if (this.val1 == "") {
        this.$message.error("商品名称不能为空");
        return;
      }
      let formData = new FormData();
      formData.append("username", this.username);
      formData.append("token", this.token);
      formData.append("p_id", this.id);
      formData.append("title", this.val1);
      formData.append("common_title", this.val16);
      formData.append("brand", this.val3);
      formData.append("item_no", this.val4);
      formData.append("origin", this.origin);
      formData.append("leadtime", this.val5);
      formData.append("specification", this.val12);
      formData.append("model", this.model);
      formData.append("paramater", this.parameter);
      formData.append("texture", this.texture);
      formData.append("color", this.color);
      formData.append("property", this.property);
      formData.append("purity", this.purity);
      formData.append("uses", this.val15);
      formData.append("molecular", this.molecular);
      formData.append("formula", this.weight);
      formData.append("CAS", this.CAS);
      formData.append("host", this.host);
      formData.append("reaction_species", this.species);
      formData.append("antigen_info", this.antigen);
      formData.append("belong", this.belong);
      formData.append("grade", this.grade);
      formData.append("editor", this.editor_chief);
      formData.append("press", this.publishing);
      formData.append("press_time", this.publi_time);
      formData.append("inventory", this.val6);
      formData.append("buy_price", this.val7);
      formData.append("selling_price", this.val8);
      formData.append("original_price", this.val9);
      if (this.rmark2 === null) {
        formData.append("info", this.rmark1);
      } else {
        formData.append("info", this.rmark2);
      }
      formData.append("classification", this.showfrom);
      formData.append("save_contidion", this.deposit);
      formData.append("doc", this.document);
      if (this.img1Type == "file") {
        formData.append("img1", this.img1);
      } else if (this.img1Type == "url") {
        formData.append("src1", this.img1);
      }
      formData.append("img1Type", this.img1Type);

      formData.append("hot", this.hot);
      formData.append("discounts", this.discounts);
      formData.append("required", this.required);
      formData.append("order_by", this.order_by);
      if (this.fileList.length == 0) {
        this.img1 = null;
        this.img1Type = "url";
      }
      let config = {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      };
      const loading = this.$loading({
        lock: true,
        text: "正在上传",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });

      var that = this;
      this.axios
        .post(this.serve + "/admin/edit_product", formData, config)
        .then(function(res) {
          if (res.data.status == "success") {
            that.$message({
              type: "success",
              message: "上传成功"
            });
            loading.close();
            if (that.list_page) {
              that.$router.push({
                path: "/admin/list" + "?page=" + that.list_page
              });
            } else {
              that.$router.push({
                path: "/admin/list" 
              });
            }
          } else if (res.data.status == "error") {
            that.$message.error(res.data.msg);
            loading.close();
          }
        });
    }
  }
};
</script>
<style lang="scss">
// table {
//     border-top: 1px solid #ccc;
//     border-left: 1px solid #ccc;
//   }
//   table td,
//   table th {
//     border-bottom: 1px solid #ccc;
//     border-right: 1px solid #ccc;
//     padding: 3px 5px;
//   }
//   table th {
//     border-bottom: 2px solid #ccc;
//     text-align: center;
//   }
.add2 {
  min-height: 1000px;
  .col1 {
    width: 182px;
    background-color: #eee;
    padding-top: 100px;
    text-align: center;
    .left_div {
      width: 182px;
      height: 54px;
      background: rgba(166, 182, 193, 1);
      position: absolute;
      left: 0;
      top: 80px;
      display: flex;
      position: relative;
      align-items: center;
      .positi {
        z-index: 1;
        width: 0;
        height: 0;
        border-top: 27px dashed transparent;
        border-bottom: 27px dashed transparent;
        border-left: 24px solid rgba(166, 182, 193, 1);
        font-size: 0;
        position: absolute;
        top: 0;
        right: -24px;
      }
      > p {
        // display: inline-block;
        margin-left: 6px;
        font-size: 18px;
        font-family: "MicrosoftYaHei";
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        text-align: center;
      }
    }
    .item {
      background-color: #a6b6c1;
      color: #fff;
      font-size: 17px;
      padding: 18px 0;
    }
    display: block;
    height: 100%;
  }

  .col2 {
    width: 870px;
    background-color: #fff;
    padding-top: 30px;
    .s {
      background-color: #f5faf9;
      text-align: center;
      .b {
        background: transparent;
        border: 0;
        line-height: 32px;
      }
    }
    .upload-text {
      color: #999;
      font-size: 13px;
      padding: 5px 0;
    }
    .upload-icon {
      width: 100px;
      height: 100px;
      border: 1px solid #dddddd;
      text-align: center;
      svg {
        height: 100px;
      }
    }
    .ps1 {
      color: #f64e62;
      line-height: 40px;
    }
    .ps2 {
      color: #999999;
      line-height: 40px;
    }
    .row {
      margin-bottom: 10px;
    }
    .label {
      text-align: right;
      padding-right: 10px;
      line-height: 40px;
    }

    .edit-btn {
      margin-left: 40px;
      button {
        padding: 0px;
      }
    }
    .input {
      line-height: 40px;
      input[type="text"] {
        width: 350px;
      }
    }
  }

  .subTitle {
    width: 1056px;
    margin: 0 auto;
    font-size: 14px;
  }
  .form {
    width: 1100px;
    margin: 0 auto;
    .upload-text {
      color: #999;
      font-size: 14px;
      padding: 5px 0;
    }
  }
  .preview-img {
    border: 1px solid #ddd;
    width: 150px;
    height: 170px;
    text-align: center;
    margin-right: 20px;
    svg {
      height: 170px;
    }
  }
  .preview-img2 {
    border: 1px solid #ddd;
    width: 150px;
    height: 170px;
    margin-right: 20px;
  }
  .preview-img2 img {
    width: 150px;
    height: 136px;
  }
  .setp {
    width: 800px;
    margin: 35px auto;
  }
  .submit {
    text-align: center;
    padding: 50px 0;
  }
  .for img {
    width: 80px;
    height: 80px;
    margin-right: 10px;
    margin-bottom: 10px;
    border: 3px solid #eee;
  }
  .for img:hover {
    border: 3px solid #0099ff;
    cursor: pointer;
  }
}
#app .layout .right .right {
  background-color: #fff;
}
.val24 textarea {
  width: 90%;
  height: 200px;
}
</style>